import React, { useMemo, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import axiosRails from '@utils/axios';
import {
  Card,
} from '@shopify/polaris';

import CTABanner from '@presentational/information/CTABanner';

import { ta } from '@utils';
import { transfersColumns } from '@utils/recordHelpers';
import FilterTableProvider from '@container/FilterTableProvider';

const propTypes = {
  transfers: PropTypes.array.isRequired,
  newURL: PropTypes.string,
  locations: PropTypes.object,
  apbLocationSet: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  sellers: PropTypes.array,
};

// TODO do this dynamic?
const tabs = [
  {
    id: 'all',
    value: "",
    content: "Todos",
    accessibilityLabel: 'All customers',
  },
  {
    id: 'pending',
    value: "pending",
    content: I18n.t("enum.status.transfer.pending"),
    accessibilityLabel: 'All customers',
  },
  {
    id: 'partial',
    value: "partial",
    content: I18n.t("enum.status.transfer.partial"),
    accessibilityLabel: 'All customers',
  },
  {
    id: 'completed',
    value: "completed",
    content: I18n.t("enum.status.transfer.completed"),
    accessibilityLabel: 'All customers',
  },
  {
    id: 'cancelled',
    value: "cancelled",
    content: I18n.t("enum.status.transfer.cancelled"),
    accessibilityLabel: 'All customers',
  },
  {
    id: 'archived',
    value: "archived",
    content: I18n.t("enum.status.transfer.archived"),
    accessibilityLabel: 'Archived',
  },
];

export const TransferIndexContainer = (props) => {
  const columnsInfo = useMemo(() => transfersColumns(props.isAdmin), [props.isAdmin]);

  const primaryAction =  props.newURL ? {
    content: I18n.t("actions.create_x", { x: I18n.t("activerecord.models.transfer.one") }),
    url: props.newURL
  } : null

  return(
    <FilterTableProvider
      tabs={ tabs }
      users={ props.sellers || [] }
      searchName="search_query"
      searchPlaceholder={ props.isAdmin ? I18n.t("form.placeholder.transfer_search.admin") : I18n.t("form.placeholder.transfer_search.seller") }
      paramsName="transfer_filters"
      statusParamName="status"

      filterURL={ props.filterURL }
      itemURL="/transfers"

      initialFilters={{
        user_id: props.sellers && props.sellers[0].value,
        search_query: '',
      }}
      initialRecords={ props.transfers }
      initialTotalPages={ props.totalPages }

      columnsInfo={ columnsInfo }
      pageProps={{
        title: I18n.t("activerecord.models.transfer.other"),
        primaryAction: primaryAction,
      }}
    > 
      { (_renderProps) => (
        <div>
          { !props.apbLocationSet &&
          <Card>
            <Card.Section>
              <CTABanner
                title={ I18n.t("app.banner.transfers_require_location.title") }
                message={ I18n.t("app.banner.transfers_require_location.body") }
                status="warning"
              />
            </Card.Section>
          </Card>
          }
        </div>
      )}
    </FilterTableProvider>
  )
}

TransferIndexContainer.propTypes = propTypes;


export default TransferIndexContainer;